import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import { MessageType } from "../types/message";
import { sendServiceChatMessage } from "../api/services/chat";

import { useServiceChatMessages } from "./useServiceChatMessages";

export const useServiceChatThread = ({ threadId, requestId }: { threadId: string; requestId?: string }) => {
  const { messages } = useServiceChatMessages(threadId);
  const chatInputRef = useRef<HTMLInputElement>(null);

  const handleOnKeyDownWithinChatInput = async (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      await handleSendTextMessage();
    }
  };

  const handleSendTextMessage = async () => {
    const messageText = chatInputRef.current?.value?.trim();
    if (!messageText) return;

    await sendTextMessage(messageText);
    if (chatInputRef.current) {
      chatInputRef.current.value = "";
    }
  };

  const sendTextMessage = async (text: string) => {
    if (!text.trim() || !threadId) return;

    const UUID = uuidv4();
    const messagePayload = {
      threadId,
      data: { text: text.trim() },
      type: "TEXT" as MessageType,
      uuid: UUID,
      requestId,
    };

    try {
      await sendServiceChatMessage(messagePayload);
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  };

  return {
    messages,
    chatInputRef,
    handleSendTextMessage,
    handleOnKeyDownWithinChatInput,
    threadId,
  };
};
